import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import faqContent from '../../content/faqContent';

import { StaticContentPageLayout } from '../StaticContentPage/StaticContentPage';

import css from '../StaticContentPage/StaticContentPage.module.css';

const renderParagraphs = paragraphs =>
  (paragraphs || []).map(paragraph => <p key={paragraph}>{paragraph}</p>);

const renderList = items => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <ul className={css.list}>
      {items.map(item => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

export const FAQContent = () => (
  <article className={css.article}>
    <header className={css.header}>
      <h1 className={css.title}>{faqContent.title}</h1>
      <p className={css.subtitle}>{faqContent.subtitle}</p>
    </header>

    {faqContent.sections.map(section => (
      <section key={section.heading} className={css.section}>
        <h2 className={css.sectionTitle}>{section.heading}</h2>

        {section.questions.map((question, index) => (
          <React.Fragment key={question.heading}>
            <div className={css.subsection}>
              <h3 className={css.subsectionTitle}>{question.heading}</h3>
              {renderParagraphs(question.paragraphs)}
              {renderList(question.listItems)}
            </div>
            {index < section.questions.length - 1 ? <hr className={css.divider} aria-hidden="true" /> : null}
          </React.Fragment>
        ))}
      </section>
    ))}
  </article>
);

export const FAQPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <StaticContentPageLayout content={faqContent} scrollingDisabled={scrollingDisabled}>
      <FAQContent />
    </StaticContentPageLayout>
  );
};

FAQPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const FAQPage = compose(connect(mapStateToProps))(FAQPageComponent);

export default FAQPage;
